module.exports = __webpack_public_path__ + "static/img/home_h122px_app_icon_tap.8e86564.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_app_icon_tap.gif
// module id = vt0b
// module chunks = 0